import { processAdsCaimpaigns } from 'helpers/ads/utils';
import { updateCaimpaignAdsConfig } from 'reduxUtils/modules/common';
import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import _get from 'lodash.get';

const processAdsInfo = async details => {
  try {
    const { layoutdata, state, context, templateConfig } = details;
    const common = {
      newkws: _get(layoutdata, 'newsKws', ''),
      kws: _get(layoutdata, 'seo.keywords', ''),
      specialId: _get(layoutdata, 'metaInfo.SpecialID'),
      navSubsecs: _get(layoutdata, 'navsubsecs', {}),
      jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
      isMobile: state?.isMobile,
      pathname: context.pathname,
      contentType: _get(layoutdata, 'metaInfo.Contenttype'),
    };
    const targetConf = {
      ...common,
      ...templateConfig,
    };
    const { keyValueObj, newCaimpaignConfig } = processAdsCaimpaigns(
      targetConf,
    );
    let revState = {};
    if (!state.isPrime && typeof window === 'undefined') {
      // Revenue Active or not
      context.store.dispatch(updateCaimpaignAdsConfig(newCaimpaignConfig));
      // Page Ads call
      await context.store.dispatch(loadPageAdCode(targetConf));
    }
    revState = context.store.getState();
    const revenueData = _get(revState, 'revenue.data', {});

    return { keyValueObj, revenueData };
  } catch (e) {
    return {};
  }
};

export default processAdsInfo;
